import {
  Button,
  Column,
  Columns,
  Container,
  Modal,
  TextInput,
} from '@resurs/midas-react'
import React from 'react'
import PropTypes from 'prop-types'
import { getText } from '../../../../internal/TextLabels'
import { format } from '../../../../models/format'

const _isEmailValid = email =>
  email && new RegExp(format.email.regex).test(email)

class ResendInvoiceModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: this.props.email || '',
      loading: false,
    }
  }

  render() {
    return (
      <Modal
        title={getText('transactions.transaction.history.resendInvoiceHeading')}
        show={this.props.show}
        hideClose
        actions={
          <div>
            <Button
              type="link"
              text={getText('default.cancel')}
              onClick={() => this.props.onClose()}
            />
            <Button
              type="normal"
              text={getText('transactions.transaction.history.send')}
              loading={this.state.loading}
              onClick={() =>
                this.setState({ loading: true }, () =>
                  this.props
                    .resendInvoice(this.state.email)
                    .then(() => this.props.onClose())
                    .catch(() => this.setState({ loading: false })),
                )
              }
              disabled={!_isEmailValid(this.state.email) || this.state.loading}
              dataCy="resend-invoice-button"
            />
          </div>
        }
        onClose={() => this.props.onClose()}
      >
        <Container>
          <Columns>
            <Column col8>
              <TextInput
                id="resend-invoice-email"
                type="email"
                onChange={e => this.setState({ email: e.target.value })}
                format={format.email}
                value={this.state.email}
              />
            </Column>
          </Columns>
        </Container>
      </Modal>
    )
  }
}

ResendInvoiceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  resendInvoice: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  email: PropTypes.string,
}

ResendInvoiceModal.defaultProps = {
  email: '',
}

export default ResendInvoiceModal
